// @ts-nocheck
import { arrayOf, shape, string } from 'prop-types'
import { FunctionComponent } from 'react'
import { compose } from 'redux'

import 'views/components/organisms/NowFaqModal/NowFaqModal.scss'
import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import Collapsible from 'views/components/organisms/Collapsible'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'
import setInnerHTML from 'views/utils/setInnerHTML'

const NowFaqModalContent: FunctionComponent<NowFaqModalContentProps> = ({
  accordion,
}: NowFaqModalContentProps) => {
  return (
    <div className="o-NowFaqModal">
      {accordion?.map(({ headline, text }, index) => {
        let position = 'middle'
        let expanded = false
        if (index === 0) {
          expanded = true
          position = 'first'
        } else if (index === accordion?.length - 1) {
          position = 'last'
        }

        return (
          <Collapsible
            key={headline}
            expanded={expanded}
            id={`frage-${index}`}
            label={headline}
            allScreensizes
            position={position}
            headingLevel="p"
            headerMaxLines={2}
            forceDisplayWhenCollapsed
            headerColor="light"
          >
            <span {...setInnerHTML(text)} />
          </Collapsible>
        )
      })}
    </div>
  )
}

const props = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  accordion: arrayOf(shape({ headline: string, text: string })).isRequired,
}

type NowFaqModalContentProps = InferPropsWithDefaults<typeof props>

export default compose(withShopAndRuntimeConfig)(NowFaqModalContent)
